"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EquipmentState = exports.EquipmentStateAttribute = void 0;
class EquipmentStateAttribute {
    constructor(attribute, amount) {
        this.attribute = attribute;
        this.amount = amount;
    }
}
exports.EquipmentStateAttribute = EquipmentStateAttribute;
class EquipmentState {
    constructor(slot, item) {
        this.slot = slot;
        this.item = item;
    }
}
exports.EquipmentState = EquipmentState;
